import React, { useState } from "react";
import Button, { ButtonColorTypes } from "../shared-components/Button";
import { PencilIcon } from "@heroicons/react/24/outline";
import ModalWebContentForm from "./ModalWebContentForm";
import { Item, ItemWithMetaData } from "../api/Items";

type Props = {
  handleAction: (action: "edit" | "cancel", values: boolean | string[] | undefined) => void;
  item: ItemWithMetaData;
  behaviors: string[];
  isAmendment?: boolean;
};

const ButtonWebcontentEdit = ({ handleAction, item, behaviors, isAmendment }: Props) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <Button
        text={
          <div className="flex gap-3 items-center px-2 py-0.5 text-gray-500">
            <PencilIcon className="w-5" />
            <span className="text-gray-700">{isAmendment ? "Edit" : "Add Flags"}</span>
          </div>
        }
        colorType={ButtonColorTypes.cancel}
        onClick={() => {
          setShowModal(true);
        }}
      />
      <ModalWebContentForm
        showModal={showModal}
        close={(item?: Item) => {
          if (item) {
            handleAction("edit", [item.external_id]);
          }
          setShowModal(false);
        }}
        initialState={{ webContentItem: item }}
        behaviors={behaviors}
        isNew={false}
      />
    </div>
  );
};

export default ButtonWebcontentEdit;
